export function addDaysToISODate(
  isoDateString: string,
  daysToAdd: number
): string {
  const date = new Date(isoDateString)
  date.setDate(date.getDate() + daysToAdd)
  return date.toISOString().substring(0, 10)
}
